import React, { useEffect, useState } from 'react';
import { NavLink } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { themeButtons } from "../../../css/themeButtons";
import { MuiThemeProvider } from "@material-ui/core/styles/";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import SignUpConfirmRedirect from "../SignUpConfirmRedirect/SignUpConfirmRedirect";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Box, makeStyles } from "@material-ui/core";
import Collapse from "@material-ui/core/Collapse";
import Card from "@material-ui/core/Card";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { GreenRadio } from "../../ObjectContacts/styles";


const useStyles = makeStyles((theme) => ({
  wrapper: {
    position: 'relative',
  },
  buttonProgress: {
    color: "#00b74a",
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

const messengerIcon = (messenger) => {
  if (messenger === 'WHATSAPP') {
    return 'whatsapp'
  }
  if (messenger === 'VIBER') {
    return 'viber'
  }
}

const SignUpWithPhone = (props) => {
  const classes = useStyles();
  const { signUp, getMessengersList, messengersList, userIsAuth, checkUserExist } = props


  const [showPassword, setShowPassword] = useState(false);
  const [notError, setNotError] = useState({
    status: true,
    message: ''
  });
  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    getMessengersList()
  }, [getMessengersList])


  const SignupSchema = Yup.object().shape({
    login: Yup.string()
      .min(11, 'Введите корректный номер телефона (пример: +79999999999)')
      .max(25, 'Введите корректный номер телефона (пример: +79999999999)')
      .required("Поле телефон не может быть пустым")
      .test('checkUserExist', async function (value) {
        if (value) {
          const isDuplicateExists = await checkDuplicate(value);

          if (isDuplicateExists) {
            return this.createError({
              message: isDuplicateExists,
            });
          }
          return true;
        }
        return true;
      }),
    client: Yup.string()
      .required('Выберите "Турист" или "Отельер"'),
    name: Yup.string()
      .max(50, 'Слишком длинное имя')
      .required('Поле не заполнено'),
    messenger: Yup.string()
      .required('Поле не заполнено'),

  });

  let timer = null
  const checkDuplicate = (valueToCheck) => {
    return new Promise(async (resolve, reject) => {
      if (timer) {
        clearTimeout(timer)
      }
      timer = setTimeout(async () => {

        let res = await checkUserExist(valueToCheck, "phone")
        if (res) {
          resolve(res.message)
        } else {
          resolve(false);
        }
      }, 500)

    });
  }

  useEffect(() => {
    if (window.hasOwnProperty('ym') !== false) {
      window.ym(43381884, 'reachGoal', 'regByPhone');
    }
  }, [])


  const onSubmit = values => {
    setNotError({...notError, status: true, message: ''})
    signUp(values, "phone").then((data) => {
      setNotError({"status" : data.status, "message" : data.data.message} );
    })
  }

  const messageBoxError = (isSubmitting) => {
    if(notError.status){
      if(isSubmitting){
        return <CircularProgress size={24} className={classes.buttonProgress}/>
      }
    }
  }


  const buttons = themeButtons();
  if (userIsAuth) {
    return <SignUpConfirmRedirect userIsAuth={userIsAuth}/>
  }
  return (
    <div className="main ps-0">
      <div className="container-fluid">
        <div className="sign-up mb-4">
          <Typography variant={"h4"} className={"mb-4"}>Регистрация</Typography>
          <Formik validationSchema={SignupSchema}
                  enableReinitialize
                  initialValues={{ login: '', messenger: '', name: '', email: '', client: '' }}
                  onSubmit={onSubmit}>
            {({ isSubmitting, errors, touched, isValid, values, dirty }) => (
              <Form>
                <div className="sign-up__form">
                  <div className="form-line">
                    <Field name="login">
                      {({ field, form }) => (

                        <TextField
                          variant="outlined"
                          size="small"
                          autoComplete="off"
                          fullWidth
                          label={"Телефон"}
                          {...field}
                          error={Boolean(errors.login)}
                          helperText={errors.login}/>

                      )}
                    </Field>
                  </div>
                  <Collapse in={errors.login === 'Пользователь с таким Логином уже существует'}
                            unmountOnExit className={'form-line text-center'}>
                    <Button component={NavLink} className={`btn ${buttons.btnGreenOutline}`}
                            variant="outlined" to={"/lk/login"}>Войти</Button>
                    <span className="mx-2">или</span>
                    <Button component={NavLink} className={`btn ${buttons.btnGreenOutline}`}
                            variant="outlined" to={"/lk/forgotpassword"}>Восстановить
                      пароль</Button>
                  </Collapse>
                  <Collapse in={errors.login !== 'Пользователь с таким Логином уже существует'}
                            unmountOnExit>

                    <div className="form-line">
                      <Field name="messenger">
                        {({ field, form }) => (
                          <FormControl

                            error={Boolean(errors.messenger && touched.messenger)}
                            fullWidth
                            variant="outlined"
                            size="small">
                            <InputLabel id="demo-simple-select-outlined-label">Выберите
                              мессенджер</InputLabel>

                            <Select
                              labelId="demo-simple-select-outlined-label"
                              label="Выберите мессенджер"
                              {...field}
                            >
                              {messengersList && Object.keys(messengersList).map(msg => (
                                <MenuItem key={msg} value={msg}>
                                  <FontAwesomeIcon icon={["fab", messengerIcon(msg)]}
                                                   className="me-1"/> {messengersList[msg]}
                                </MenuItem>)
                              )}

                            </Select>

                            {errors.messenger && touched.messenger && String(errors.messenger)
                              ?
                              <FormHelperText>{errors.messenger && touched.messenger && String(errors.messenger)}</FormHelperText>
                              : null}

                          </FormControl>
                        )}
                      </Field>
                    </div>
                    <div className="form-line">
                      <Field name="name">
                        {({ field, form }) => (
                          <TextField size="small"
                                     {...field}
                                     type="text" variant="outlined"
                                     className={"w-100"}
                                     label={"Ваше имя"}
                                     error={Boolean(touched.name && errors.name)}
                                     helperText={
                                       errors.name &&
                                       touched.name &&
                                       String(errors.name)
                                     }
                          />

                        )}
                      </Field>
                    </div>
                    <Card className="card card-reserve">
                      <p className="title">Резервные контакты</p>
                      <div className="form-line">
                        <Field name="email">
                          {({ field, form }) => (
                            <TextField size="small"
                                       {...field}
                                       type="text" variant="outlined"
                                       className={"w-100"}
                                       label={"Email"}
                            />

                          )}
                        </Field>
                      </div>
                     
                      <Typography variant="caption" component="span" className="text-center"
                                  className="caption">Укажите дополнительные контактные данные,
                        чтобы восстановить доступ к вашему аккаунту в случае отсутствия доступа
                        к вашему телефону</Typography>
                    </Card>
                    <Field type="radio" name={"client"}>
                      {({ field }) => (

                        <RadioGroup {...field} className="form-line text-center ">
                          <div className={"flex-row justify-content-center"}>
                            <FormControlLabel value={"Y"} className="me-5"
                                              control={<GreenRadio/>} label={"Я отельер"}/>
                            <FormControlLabel value={"N"} control={<GreenRadio/>}
                                              label={"Я турист"}/>
                          </div>

                          {errors.client && touched.client
                            ?
                            <FormHelperText
                              style={{
                                color: "#f44336",
                                textAlign: "center"
                              }}>{errors.client && touched.client && String(errors.client)}</FormHelperText>
                            : null}

                        </RadioGroup>


                      )}
                    </Field>

                  </Collapse>

                </div>
                {!notError.status && <Box style={{marginTop: 10}} className='alert alert-danger'>{notError.message}</Box>}
                <div className="row text-center justify-content-center">
                  <div className={`col-auto mb-2 ${classes.wrapper}`}>
                    <Button disabled={(!isValid || isSubmitting || !dirty) && notError.status}
                            className={`${buttons.btnGreen} px-5`} type="submite"
                            variant="contained">Отправить</Button>
                   {messageBoxError(isSubmitting)}
                  </div>

                  <div className='col-12 mb-2 mt-2'>
                    У Вас уже есть аккаунт? <Link component={NavLink} to="/lk/login">Войти</Link>
                  </div>
                </div>
                <div className="d-flex mt-3">
                  <Typography variant="caption" component="span" className="text-center"
                              style={{ fontSize: "10px" }}>Нажимая кнопку
                    "Отправить" Я подтверждаю, что даю согласие на обработку своих персональных
                    данных и
                    согласен с
                    <Link component="a" target="_blank"
                          href="https://edem-v-gosti.ru/rules/"> Политикой
                      конфиденциальности</Link> и
                    <Link component="a" target="_blank"
                          href="https://edem-v-gosti.ru/confidential/"> Пользовательским
                      соглашением</Link>
                  </Typography>
                </div>

              </Form>

            )}
          </Formik>

        </div>

      </div>
    </div>
  );
}


export default SignUpWithPhone;
